import { httpClient } from '@pascal/pascal-core';
import { errorHandler } from '../../module/error/ErrorHandler';

export const onFulfilled = res => res?.data?.result;

export const onRejected = error => {
  errorHandler.handle(error?.response?.data);
  throw error;
};

httpClient.interceptors.response.use(onFulfilled, onRejected);